import { ComponentChildren, ComponentChild } from 'preact'
import { PureComponent, createContext } from 'preact-compat'
import Icon from '../../assets'
import idGenerator from '../../utils/idGenerator'

let defaultIds: undefined|string
export const LabelId = createContext(defaultIds)
export const ValidationErrorId = createContext(defaultIds)

interface LabelProps {
  children: ComponentChildren
  isControl?: boolean
}

export class Label extends PureComponent<LabelProps> {
  render () {
    const { children, isControl } = this.props

    return (
      <LabelId.Consumer>
        {(id) => {
          return (
            <label for={id} className={`a-label a-label--app-${isControl ? 'control' : 'destination'}`}>
              {children}
            </label>
          )
        }}
      </LabelId.Consumer>
    )
  }
}

interface ValidationErrorProps {
  children: ComponentChildren
  isControl?: boolean
}

export class ValidationError extends PureComponent<ValidationErrorProps> {
  render () {
    const { children, isControl } = this.props

    return (
      <ValidationErrorId.Consumer>
        {(id) => {
          return (
            <div className={`a-validation-error a-validation-error--app-${isControl ? 'control' : 'destination'}`}>
              <Icon customClass='a-validation-error__icon' icon='warning' />
              <span id={id} className='a-validation-error__message'>{children}</span>
            </div>
          )
        }}
      </ValidationErrorId.Consumer>
    )
  }
}

interface InputUnitProps {
  children: ComponentChildren
  error?: string | ComponentChild
  isControl?: boolean
  label?: string | ComponentChild
}

class InputUnit extends PureComponent<InputUnitProps> {
  render () {
    const { children, error, isControl, label } = this.props

    return (
      <LabelId.Provider value={label ? idGenerator(String(label)) : undefined}>
        <ValidationErrorId.Provider value={error ? idGenerator('validation-error') : undefined}>
          <div className='m-input-unit'>
            {label && <Label isControl={isControl}>{label}</Label>}
            {children}
            {error && <ValidationError isControl={isControl}>{error}</ValidationError>}
          </div>
        </ValidationErrorId.Provider>
      </LabelId.Provider>
    )
  }
}

export default InputUnit
